<template>
    <div>
        <form @submit.prevent="onSubmit">
            <div class="title-container" v-if="modulo === 'booking'">
                <h2 class="search-title">{{ searchboxheadlineflights[getCurrentLocale] }}</h2>
                <p>{{ searchboxheadlineflights2[getCurrentLocale] }}</p>
                <i class="soap-icon-plane-right takeoff-effect"></i>
            </div>
            <div class="title-container" v-if="modulo === 'services'" v-bind:style="{ background: '#4A6E89' }">
                <h2 class="search-title">{{ searchboxheadlineservices[getCurrentLocale] }}</h2>
                <p>{{ searchboxheadlineflights2[getCurrentLocale] }}</p>
                <i class="soap-icon-plane-right takeoff-effect"></i>
            </div>



            <div class="search-content">
                <!-- >>> Groupbooking? -->
                <div class="row choose-travel" style="padding-bottom: 25px;" v-if="modulo === 'booking'">
                    <div class="col-xs-4">
                        <label class="radio radio-inline">
                            <input type="radio" name="choose-groupornot" value="1" v-on:change="travelingroup = false;" checked>{{ normalbooking[getCurrentLocale] }}
                        </label>
                    </div>
                    <div class="col-xs-4">
                        &nbsp;
                    </div>
                    <div class="col-xs-4">
                        <label class="radio radio-inline">
                            <input type="radio" name="choose-groupornot" value="2" v-on:change="travelingroup = true;">{{ groupbooking[getCurrentLocale] }}
                        </label>
                    </div>
                </div>



                <hr>



                <!-- >>> FlightType -->
                <div class="row choose-travel" v-if="modulo === 'booking'">
                    <div class="col-xs-4">
                        <label class="radio radio-inline">
                            <input type="radio" name="choose-travel" value="1" v-on:change="outwardonly = false; returntoother = false;" checked>{{ outwardandreturnflight[getCurrentLocale] }}
                        </label>
                    </div>
                    <div class="col-xs-4">
                        <label class="radio radio-inline">
                            <input type="radio" name="choose-travel" value="2" v-on:change="outwardonly = true; returntoother = false;">{{ outwardonlyflight[getCurrentLocale] }}
                        </label>
                    </div>
                    <!-- >>> FlightType: 'returntoother' -->
                    <div class="col-xs-4" v-show="modulo !== 'services'">
                        <label class="radio radio-inline">
                            <input type="radio" name="choose-travel" value="2" v-on:change="outwardonly = false; returntoother = true; onChange_Radio_checkIfSomethingAlreadyChosen();">{{ returntootherflight[getCurrentLocale] }}
                        </label>
                    </div>
                </div>
                <div class="row choose-travel" v-if="modulo === 'services'">
                    <div class="col-xs-4">
                        <label class="radio radio-inline radiosrvcs">
                            <input type="radio" name="choose-travel" value="1" v-on:change="outwardonly = false; returntoother = false;" checked>{{ outwardandreturnflight[getCurrentLocale] }}
                        </label>
                    </div>
                    <div class="col-xs-4">
                        <label class="radio radio-inline radiosrvcs">
                            <input type="radio" name="choose-travel" value="2" v-on:change="outwardonly = true; returntoother = false;">{{ outwardonlyflight[getCurrentLocale] }}
                        </label>
                    </div>
                    <!-- >>> FlightType: 'returntoother' -->
                    <div class="col-xs-4" v-show="modulo === 'services'">
                        <label class="radio radio-inline radiosrvcs">
                            <input type="radio" name="choose-travel" value="2" v-on:change="outwardonly = false; returntoother = true; onChange_Radio_checkIfSomethingAlreadyChosen();">{{ returntootherflight[getCurrentLocale] }}
                        </label>
                    </div>
                </div>



                <hr>



                <!-- >>> Departure/Destination -->
                <h5 class="title">{{ where[getCurrentLocale] }}</h5>
                <!-- >>> Departure/Destination: 'booking' -->
                <div class="row" v-if="modulo === 'booking'">
                    <div class="col-xs-6">
                        <label>{{ yourplaceofdeparture[getCurrentLocale] }}:</label>
                        <v-select name="depArprtCode" ref="depArprtCode" :clearable="false" :disabled="!departuresLoaded" v-model="depArprtCode" :options="airportsOrigins" label="l" key="i" :value="i" class="style-chooser" :placeholder="this.departureairport[this.getCurrentLocale]" @input="call_listAirportsDestinations"></v-select>
                    </div>

                    <div class="col-xs-6">
                        <label>{{ yourplaceofdestination[getCurrentLocale] }}:</label>
                        <v-select name="desArprtCode" ref="desArprtCode" :clearable="false" :disabled="!destinationsLoaded" v-model="desArprtCode" :options="airportsDestinations" label="l" key="i" :value="i" class="style-chooser" :placeholder="this.destinationairport[this.getCurrentLocale]" @input="call_listAirportsReturnToOther"></v-select>
                    </div>
                </div>
                <!-- >>> Departure/Destination: 'services' -->
                <div class="row" v-if="modulo === 'services'">
                    <div class="col-xs-6">
                        <label>{{ yourplaceofdeparture[getCurrentLocale] }}:</label>
                        <v-select name="depArprtCode" ref="depArprtCode" :clearable="false" :disabled="!departuresLoaded" v-model="depArprtCode" :options="airportsOrigins" label="l" key="i" :value="i" class="style-chooser-srvcs" :placeholder="this.departureairport[this.getCurrentLocale]" @input="call_listAirportsDestinations"></v-select>
                    </div>

                    <div class="col-xs-6">
                        <label>{{ yourplaceofdestination[getCurrentLocale] }}:</label>
                        <v-select name="desArprtCode" ref="desArprtCode" :clearable="false" :disabled="!destinationsLoaded" v-model="desArprtCode" :options="airportsDestinations" label="l" key="i" :value="i" class="style-chooser-srvcs" :placeholder="this.destinationairport[this.getCurrentLocale]" @input="call_listAirportsReturnToOther"></v-select>
                    </div>
                </div>
                <!-- >>> Departure/Destination: 'returntoother' -->
                <div class="row" v-if="modulo === 'booking' && returntoother === true"  style="padding-top: 20px;">
                    <div class="col-xs-6">
                        <label>{{ yourplaceofdeparturetoother[getCurrentLocale] }}:</label>
                        <v-select name="depArprtCode_returntoother" ref="depArprtCode_returntoother" :clearable="false" disabled v-model="depArprtCode_returntoother" label="l" key="i" :value="i" class="style-chooser" :placeholder="this.departureairporttoother[this.getCurrentLocale]"></v-select>
                    </div>

                    <div class="col-xs-6">
                        <label>{{ yourplaceofdestinationtoother[getCurrentLocale] }}:</label>
                        <v-select name="desArprtCode_returntoother" ref="desArprtCode_returntoother" :clearable="false" :disabled="!returntootherLoaded" v-model="desArprtCode_returntoother" label="l" key="i" :value="i" class="style-chooser" :placeholder="this.destinationairporttoother[this.getCurrentLocale]" :options="airportsReturntoother"></v-select>
                    </div>
                </div>
                <div class="row" v-if="modulo === 'services' && returntoother === true" style="padding-top: 20px;">
                    <div class="col-xs-6">
                        <label>{{ yourplaceofdeparturetoother[getCurrentLocale] }}:</label>
                        <v-select name="depArprtCode_returntoother" ref="depArprtCode_returntoother" :clearable="false" disabled v-model="depArprtCode_returntoother" label="l" key="i" :value="i" class="style-chooser-srvcs" :placeholder="this.departureairporttoother[this.getCurrentLocale]"></v-select>
                    </div>

                    <div class="col-xs-6">
                        <label>{{ yourplaceofdestinationtoother[getCurrentLocale] }}:</label>
                        <v-select name="desArprtCode_returntoother" ref="desArprtCode_returntoother" :clearable="false" :disabled="!returntootherLoaded" v-model="desArprtCode_returntoother" label="l" key="i" :value="i" class="style-chooser-srvcs" :placeholder="this.destinationairporttoother[this.getCurrentLocale]" :options="airportsReturntoother"></v-select>
                    </div>
                </div>



                <hr>



                <!-- >>> Date Dep/Date Des -->
                <h5 class="title">{{ when[getCurrentLocale] }}</h5>
                <div class="row">
                    <div class="col-xs-6">
                        <label>{{ departuredate[getCurrentLocale] }}:</label>
                        <div class="datepicker-wrap sundair" v-if="modulo === 'booking'">
                            <input type="text" name="date_from" class="input-text full-width" placeholder="dd.mm.yy" :value="today">
                        </div>
                        <div class="datepicker-wrap sundairsrvcs" v-if="modulo === 'services'">
                            <input type="text" name="date_from" class="input-text full-width" placeholder="dd.mm.yy" :value="today">
                        </div>
                    </div>

                    <div class="col-xs-6">
                        <label v-show="outwardonly === false">{{ returndate[getCurrentLocale] }}:</label>
                        <div class="datepicker-wrap sundair" v-show="outwardonly === false" v-if="modulo === 'booking'">
                            <input type="text" name="date_to" class="input-text full-width" placeholder="dd.mm.yy" :value="tommorow">
                        </div>
                        <div class="datepicker-wrap sundairsrvcs" v-show="outwardonly === false" v-if="modulo === 'services'">
                            <input type="text" name="date_to" class="input-text full-width" placeholder="dd.mm.yy" :value="tommorow">
                        </div>
                    </div>
                </div>



                <hr>


                <!-- >>> Who? No Group -->
                <h5 class="title">{{ who[getCurrentLocale] }}</h5>
                <div class="row" v-show="travelingroup === false">
                    <div class="col-xs-4 col-md-4">
                        <label>{{ adult[getCurrentLocale] }}<br>{{ adultyears[getCurrentLocale] }}:</label>
                        <div class="selector">
                            <select ref="noADT">
                                <option v-for="(value, key) in listOfPaxes" :value="value" :key="key">{{ value }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-xs-4 col-md-4">
                        <label>{{ child[getCurrentLocale] }}<br>{{ childyears[getCurrentLocale] }}:</label>
                        <div class="selector">
                            <select ref="noCHD">
                                <option v-for="(value, key) in listOfPaxes" :value="value" :key="key">{{ value }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-xs-4 col-md-4">
                        <label>{{ infant[getCurrentLocale] }}<br>{{ infantyears[getCurrentLocale] }}:</label>
                        <div class="selector">
                            <select ref="noINF">
                                <option v-for="(value, key) in listOfPaxes" :value="value" :key="key">{{ value }}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <!-- >>> Who? Group -->
                <div class="row" v-show="travelingroup === true">
                    <div class="col-xs-6 col-md-6">
                        <label>{{ passengersinyourbooking[getCurrentLocale] }}:</label>
                        <div class="selector">
                            <select ref="noPassengersInGroup">
                                <option v-for="pax in 40" :value="pax" :key="pax">{{ pax }}</option>
                            </select>
                        </div>
                    </div>
                </div>



                <hr>



                <!-- >>> Submit -->
                <button type="submit" class="btn-medium icon-check uppercase full-width" v-if="modulo === 'booking' && depArprtCode !== '' && desArprtCode !== ''">{{ findflights[getCurrentLocale] }}</button>
                <a class="button btn-medium uppercase full-width silver" v-if="modulo === 'booking' && (depArprtCode === '' || desArprtCode === '')">{{ findflights[getCurrentLocale] }} </a>


                <button type="submit" class="btn-medium icon-check-srvcs uppercase full-width" v-if="modulo === 'services' && depArprtCode !== '' && desArprtCode !== ''" v-bind:style="{ background: '#4A6E89' }">{{ findflights[getCurrentLocale] }}</button>
                <a class="button btn-medium uppercase full-width silver" v-if="modulo === 'services' && (depArprtCode === '' || desArprtCode === '')">{{ findflights[getCurrentLocale] }} </a>
            </div>
        </form>




        <!-- >>> Modal - Modal - Modal - Modal - Modal - Modal - Modal - Mod -->
        <!-- >>> Modal - Modal - Modal - Modal - Modal - Modal - Modal - Mod -->
        <modal name="booking-error-modal"
                transition="nice-modal-fade"
                classes="demo-modal-class"
                :min-width="100"
                :min-height="100"
                :pivot-y="0.5"
                :adaptive="true"
                :scrollable="true"
                :reset="true"
                width="500px"
                height="auto"
                @before-open="beforeOpen"
                @opened="opened"
                @closed="closed"
                @before-close="beforeClose">
                <div class="booking-error-modal-content" style="border: 2px solid red;">
                    <section id="content" style="padding:20px; min-height: 100px;">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="container shortcode travel-ideas">
                                    <h3 class="idea-title" style="margin-bottom:10px;"><span class="index"><i class="soap-icon-notice circle"></i></span>{{ modal_headline_rebooking_error[getCurrentLocale] }}</h3>
                                </div>

                                <div>
                                    <br />
                                    <h4 v-html="modal_content_rebooking_error[getCurrentLocale]"></h4>
                                </div>
                            </div>
                        </div>
                    </section>
                    <button type="button" class="btn-large full-width totalbutton sundair" style="cursor: initial; outline: none !important; outline-style: none !important; margin-bottom: 0px;" @click.prevent="onClick_CloseModal()"> {{ closemodal[getCurrentLocale] }}</button>
                </div>
        </modal>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { mapActions } from 'vuex';

    import axios from 'axios';
    import moment from 'moment';
    import { eventBus } from '../../../main';


    export default {

        /* >>> *************************************************************** / /* Props */
        props: ['modulo'],
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* Data */
        data: function() {

            return {
                // ----------------------------------
                searchboxheadlineflights: {
                    en: 'Search and book Flights',
                    de: 'Flüge suchen und buchen',
                },
                searchboxheadlineservices: {
                    en: 'Find Flights and add Services',
                    de: 'Flüge finden und Services hinzubuchen',
                },
                searchboxheadlineflights2: {
                    en: "Let's get straight to the point!",
                    de: 'Kommen wir DIREKT zur Sache!',
                },
                // ----------------------------------
                outwardandreturnflight: {
                    en: 'Round Trip',
                    de: 'Hin- und Rückflug',
                },
                outwardonlyflight: {
                    en: 'One way only',
                    de: 'nur der Hinflug',
                },
                returntootherflight: {
                    en: 'Return new destination',
                    de: 'Rückflug neues Ziel',
                },
                normalbooking: {
                    en: 'Normal booking',
                    de: 'Normale Buchung',
                },
                groupbooking: {
                    en: 'Group booking',
                    de: 'Gruppenbuchung',
                },
                // ----------------------------------
                where: {
                    en: 'Where',
                    de: 'Wohin',
                },
                yourplaceofdeparture: {
                    en: 'YOUR DEPARTURE',
                    de: 'IHR ABFLUGSORT',
                },
                yourplaceofdestination: {
                    en: 'YOUR DESTINATION',
                    de: 'IHR ZIELORT',
                },
                yourplaceofdeparturetoother: {
                    en: 'YOUR NEW DEPARTURE',
                    de: 'IHR NEUER ABFLUGSORT',
                },
                yourplaceofdestinationtoother: {
                    en: 'YOUR NEW DESTINATION',
                    de: 'IHR NEUER ZIELORT',
                },


                departureairport: {
                    en: 'Please choose your departure airport',
                    de: 'Wählen Sie Ihren Startflughafen',
                },
                destinationairport: {
                    en: 'Please choose your destination airport',
                    de: 'Wählen Sie Ihren Zielflughafen',
                },
                departureairporttoother: {
                    en: 'Please choose your departure airport',
                    de: 'Wählen Sie zuerst Hin-Rückflug',
                },
                destinationairporttoother: {
                    en: 'Please choose your new destination airport',
                    de: 'Wählen Sie Ihren neuen Zielflughafen',
                },

                // ----------------------------------
                when: {
                    en: 'When',
                    de: 'Wann',
                },
                departuredate: {
                    en: 'Date Departure',
                    de: 'Abflugdatum',
                },
                returndate: {
                    en: 'Date Return',
                    de: 'Rückflugdatum',
                },
                // ----------------------------------
                who: {
                    en: 'Who',
                    de: 'Wer',
                },
                adult: {
                    en: 'Adults',
                    de: 'Erwachsene',
                },
                adultyears: {
                    en: '(From 12+ Years)',
                    de: '(Ab 12+ Jahre)',
                },
                child: {
                    en: 'Children',
                    de: 'Kinder',
                },
                childyears: {
                    en: '(2 to 12 Years)',
                    de: '(2 bis 12 Jahre)',
                },
                infant: {
                    en: 'Infants',
                    de: 'Kleinkinder',
                },
                infantyears: {
                    en: '(Up to 2 Years)',
                    de: '(Bis 2 Jahre)',
                },
                passengersinyourbooking: {
                    en: 'Passengers in the booking',
                    de: 'Passagiere in der Buchung',
                },
                // ----------------------------------
                findflights: {
                    en: 'FIND FLIGHTS',
                    de: 'FLÜGE FINDEN',
                },
                tomanypeople: {
                    en: 'Please use our group booking form for flight bookings of 11 or more passengers or contact customer service..',
                    de: 'Bitte nutzen Sie bei einer Flugbuchung ab 11 Passagiere unser Gruppenbuchungsformular oder wenden Sie sich an den Kundenservice..',
                },
                noretflightonroundtrip: {
                    en: 'Dear customer, for your search request outbound or return flights are already fully booked. Please start your search again.',
                    de: 'Lieber Kunde, für Ihre Suchanfrage sind bereits Hin- oder Rückflüge ausgebucht. Bitte starten Sie Ihre Suche erneut.',
                },
                // ----------------------------------------
                modal_headline_rebooking_error: {
                    en: 'Attention: No Flights anymore',
                    de: 'Achtung: Keine Flüge mehr',
                },
                modal_content_rebooking_error: {
                    en: 'Dear customer, for your search request outbound or return flights are already fully booked.<br /><br />Please start your search again.',
                    de: 'Lieber Kunde, für Ihre Suchanfrage sind bereits Hin- oder Rückflüge ausgebucht.<br /><br />Bitte starten Sie Ihre Suche erneut.',
                },
                closemodal: {
                    en: 'Close',
                    de: 'Schliessen',
                },
                // >>> ---------------------------------------------------------
                // >>> --------------------------------------------------------- Airport Lists
                airportsOrigins: [],
                airportsDestinations: [],
                airportsReturntoother: [],

                // >>> --------------------------------------------------------- SearchForm Models
                depArprtCode: '',               // model, new select Field
                desArprtCode: '',               // model, new select Field
                depArprtCode_returntoother: '', // model, new select Field
                desArprtCode_returntoother: '', // model, new select Field

                // >>> --------------------------------------------------------- Flags
                departuresLoaded: false,        // Flag: Dep Aiports loaded?
                destinationsLoaded: false,      // Flag: Des Aiports loaded?
                returntootherLoaded: false,     // Flag: Return to other Aiports loaded?

                outwardonly: false,             // Flag/Mode: ReturnFlight too?
                returntoother: false,           // Flag/Mode: ReturnFlight to other destination?

                // >>> ---------------------------------------------------------
                today: moment().add(1, 'days').format('DD.MM.YYYY'),
                tommorow: moment().add(2, 'days').format('DD.MM.YYYY'),
                // >>> ---------------------------------------------------------
                listOfPaxes: { 0: '0', 1: '1', 2: '2', 3: '3', 4: '4', 5: '5', 6: '6', 7: '7', 8: '8' },
                // noADT: 1,
                // noCHD: '0',
                // noINF: '0',
                // noPassengersInGroup: '10',
                travelingroup: false,
            };

        }, // eo function data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
                'getBookingUsersSearchData',
                'getBookingFlightSearchResults',
                'getBookingDepArprtCode',
            ]),

        }, // eo computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::mounted
        *
        * Desc: Initialize Select Fields.
        * Note:
        *
        */
        mounted: function() {

            var me = this,
                localStorageAgencyUser = JSON.parse(localStorage.getItem('sdr__agency_username'));


            me.$toc('>>> shared/flightsearch/FlighSearchTab.vue >>> mounted');
            // >>> Agency in localStorage? ----------------
            if (localStorageAgencyUser !== null) {
                this.call_listAirportsOrigines();
            }

            this.$refs.noADT.value = 1; // @startup
            this.$refs.noPassengersInGroup.value = 10; // @startup

            me.$selectInits(this.modulo, this.getCurrentLocale);

        },  // eo function mounted()


        /***********************************************************************
        * Lifecyclehook::updated
        *
        * Desc:
        * Note:
        *
        */
        updated: function() {

            var me = this;


            me.$toc('>>> shared/flightsearch/FlighSearchTab.vue >>> updated');
            // this.$refs.noADT.value = 1; // @startup
            // this.$refs.noPassengersInGroup.value = 10; // @startup

            me.$selectInits(this.modulo, this.getCurrentLocale);

        },  // eo function updated()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_FlagSharedShowFlightSearchResults', // Control Flag
                'actn_FlagServicesShowBookingnoSearchResults', // Control Flag
                'actn_setBookingAirports', // Part 1
                'actn_setBookingUsersSearchData', // Part 2
                'actn_setBookingFlightSearchResults', // set: SearchResults
                'actn_FlagBookingOutwardFlightSelected', // set: 'Outward Flight selected
                'actn_FlagBookingReturnFlightSelected', // set: 'Return Flight selected
                'actn_setBookingFlightIdSelectedOutward', // set: 'Out Selected Flight Id'
                'actn_setBookingFlightIdSelectedReturn', // set: 'Ret Selected Flight Id'
                'actn_set_areWeInServicesBookingNoMode', // set:
                'actn_set_areWeInServicesGroupbookingMode', // set:
            ]),


            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onSubmit()
            *
            * Desc: SearchForm gets submitted.
            * Note:
            * Note:
            *
            */
            onSubmit: function(submitEvent) {

                let me = this,
                    depAfter = '',
                    myDepPickerDate,
                    theActualTime,
                    isToday,
                    date_to,
                    date_from,
                    requestParamObject = {};


                me.$toc('>>> shared/flightsearch/FlighSearchTab.vue >>> onSubmit');
                // >>> 0. Empty Airports 1 ------------------------------------- // Mode: '!returntoother'
                if (this.returntoother === false) {
                    if (this.depArprtCode === null || this.desArprtCode === null || this.depArprtCode === '' || this.desArprtCode === '') {
                        return;
                    }
                }

                // >>> 0a. Empty Airports 2 ------------------------------------ // Mode: 'returntoother'
                if (this.returntoother === true) {
                    if (this.depArprtCode === null || this.desArprtCode === null || this.desArprtCode_returntoother === '') {
                        return;
                    }
                }

                // >>> 0b. To many Pax -----------------------------------------
                if (this.travelingroup === false) {
                    if (+this.$refs.noADT.value + +this.$refs.noCHD.value + +this.$refs.noINF.value > 10) {
                        me.$toasted.global.sdr_app_error({
                            message : this.tomanypeople[this.getCurrentLocale]
                        });
                        return;
                    }
                }




                // >>> 1. Check for Today&depAfter-Time ------------------------
                date_from = submitEvent.target.elements.date_from.value.split('.');
                myDepPickerDate = moment(date_from[2] + '-' + date_from[1] + '-' + date_from[0]).format('YYYY-MM-DD');
                theActualTime = moment().format('HH:mm:ss');
                isToday = moment(String(myDepPickerDate)).isSame(moment().format('YYYY-MM-DD'));
                if (isToday) {
                    depAfter = moment(date_from[2] + '-' + date_from[1] + '-' + date_from[0]).format('YYYY-MM-DDT') + theActualTime;
                }
                if (!isToday) {
                    depAfter = moment(date_from[2] + '-' + date_from[1] + '-' + date_from[0]).format('YYYY-MM-DDT00:00:ss+0000');
                }



                // >>> 2. Builds Object ----------------------------------------
                requestParamObject = {
                    depArprtCode: this.depArprtCode.i, // submitEvent.target.elements.depArprtCode.value,
                    desArprtCode: this.desArprtCode.i, // submitEvent.target.elements.desArprtCode.value,
                    noADT: this.travelingroup === true ? String(this.$refs.noPassengersInGroup.value) : this.$refs.noADT.value, // this.noADT,
                    noCHD: this.travelingroup === true ? '0' : this.$refs.noCHD.value, // this.noCHD,
                    noINF: this.travelingroup === true ? '0' : this.$refs.noINF.value, // this.noINF,
                    ojArprtCode: '', // not clear
                    ojType: '', // not clear
                    depAfter: depAfter,
                    rTrip: false,
                    limit: 5,
                };



                // >>> 3. Oneway || Roundtrip ? --------------------------------
                if (this.outwardonly === false) {
                    date_to = submitEvent.target.elements.date_to.value.split('.');
                    requestParamObject.retAfter = moment(date_to[2] + '-' + date_to[1] + '-' + date_to[0]).format('YYYY-MM-DDTHH:mm:ss+0000');
                    requestParamObject.rTrip = true;
                }

                // >>> 3. Returntoother ? --------------------------------------
                if (this.returntoother === true) {
                    requestParamObject.ojType = 'LEFT';
                    requestParamObject.ojArprtCode = this.desArprtCode_returntoother.i;
                }



                // >>> 4. Go Go Go ---------------------------------------------
                if (requestParamObject.depArprtCode !== '' && requestParamObject.desArprtCode !== '') {
                    me.actn_FlagSharedShowFlightSearchResults(false);           // Hide 'Section'
                    me.actn_FlagServicesShowBookingnoSearchResults(false);      // Hide 'Section'

                    this.actn_setBookingAirports({                              // remember in state
                        depArprtCode: requestParamObject.depArprtCode,
                        depArprtName: this.depArprtCode.l,
                        desArprtCode: requestParamObject.desArprtCode,
                        desArprtName: this.desArprtCode.l,
                        depArprtCode_returntoother: this.returntoother === true ? requestParamObject.desArprtCode : null,
                        depArprtName_returntoother: this.returntoother === true ? this.desArprtCode.l : null,
                        desArprtCode_returntoother: this.returntoother === true ? requestParamObject.ojArprtCode : null,
                        desArprtName_returntoother: this.returntoother === true ? this.desArprtCode_returntoother.l : null
                    });
                    this.actn_setBookingUsersSearchData(requestParamObject);    // remember in state


                    this.actn_set_areWeInServicesBookingNoMode(false);                  // remember in state, set flag
                    this.actn_set_areWeInServicesGroupbookingMode(this.travelingroup);  // remember in state, set flag


                    this.call_listFlights(requestParamObject);                  // call
                }

            }, // eo function onSubmit()




            /******************************************************************* 'ServiceCalls - Common'
            * ServiceCalls:
            *******************************************************************/
            /******************************************************************* Shared: 'Booking', 'Services'
            * Call::'/booking/origines'
            * Call::'/registration/destinations/ZRH'
            *
            * Desc: Getting Airports - Origines ('listAirports').
            * Note: Via Endpoint '/booking' or '/registration'.
            *
            */
            call_listAirportsOrigines: function() {

                var me = this,
                    hdrs = '',
                    url = '';


                me.$toc('>>> shared/flightsearch/FlighSearchTab.vue >>> call_listAirportsOrigines');
                // >>> Decide Modulo -------------------------------------------
                if (this.modulo === 'booking') {
                    url = '/booking/origines/';
                }
                if (this.modulo === 'services') {
                    url = '/registration/origines'
                }


                // >>> Send Ajax Request ---------------------------------------
                me.$vp_m();
                axios.get(url)
                    .then(function(response) { // 'OK'
                        me.$vp_um();
                        hdrs = response.headers["air41-status"];
                        switch (hdrs) {
                            case 'OK': // 'OK'
                                me.airportsOrigins = response.data.originesRS.dep;
                                me.airportsOrigins.sort((a,b) => (a.l > b.l) ? 1 : ((b.l > a.l) ? -1 : 0));
                                me.departuresLoaded = true;
                                break;
                            default: // 'ERROR'
                                me.$toasted.global.sdr_app_error({
                                    message : response.headers["air41-error"]
                                });
                                break;
                        };
                    })
                    .catch(function(error) { // 'ERROR'
                        me.$vp_um();
                        me.$toasted.global.sdr_app_error({
                            message : 'Service unavailable'
                        });
                    });

            }, // eo funtion call_listAirportsOrigines()


            /******************************************************************* Shared: 'Booking', 'Services'
            * Call::'/booking/destinations/ZRH'
            * Call::'/registration/destinations/ZRH'
            *
            * Desc: Getting Airports - Destinations ('listAirports').
            * Note: Via Endpoint '/booking' or '/registration'.
            *
            */
            call_listAirportsDestinations: function(event) {

                var me = this,
                    hdrs = '',
                    url = '';


                me.$toc('>>> shared/flightsearch/FlighSearchTab.vue >>> call_listAirportsDestinations');
                // >>> Resets --------------------------------------------------
                this.desArprtCode = '';                 // reset model & co
                this.depArprtCode_returntoother = '';
                this.desArprtCode_returntoother = '';
                this.airportsReturntoother = [];
                this.returntootherLoaded = false;

                this.onChange_FlightsSearchForm();      // reset


                // >>> Decide Modulo -------------------------------------------
                if (this.modulo === 'booking') {
                    url = '/booking/destinations/';
                }
                if (this.modulo === 'services') {
                    url = '/registration/destinations/';
                }

                // >>> Send Ajax Request ---------------------------------------
                me.$vp_m();
                axios.get(url + event.i)
                    .then(function(response) {  // 'OK'
                        me.$vp_um();
                        hdrs = response.headers["air41-status"];
                        switch (hdrs) {
                            case 'OK': // 'OK'
                                me.airportsDestinations = response.data.destinationsRS.des;
                                me.airportsDestinations.sort((a,b) => (a.l > b.l) ? 1 : ((b.l > a.l) ? -1 : 0));
                                me.destinationsLoaded = true;
                                break;
                            default: // 'ERROR'
                                // me.$toc('I am in Header Error');
                                me.$toasted.global.sdr_app_error({
                                    message : response.headers["air41-error"]
                                });
                                break;
                        };
                    })
                    .catch(function(error) { // 'ERROR'
                        me.$vp_um();
                        me.$toasted.global.sdr_app_error({
                            message : 'Service unavailable'
                        });
                    });

            }, // eo funtion call_listAirportsDestinations()


            /******************************************************************* Shared: 'Booking'
            * Call::'/booking/destinations/ZRH'
            *
            * Desc: Getting Airports - 'Return to other' ('listAirports').
            * Note:
            *
            */
            call_listAirportsReturnToOther: function(event) {

                var me = this,
                    hdrs = '',
                    url = '';


                me.$toc('>>> shared/flightsearch/FlighSearchTab.vue >>> call_listAirportsReturnToOther');
                if (this.returntoother === false) { // Guard
                    return;
                };

                this.depArprtCode_returntoother = this.desArprtCode;    // set
                this.desArprtCode_returntoother = '';                   // reset model (return to other)


                // >>> Decide Modulo -------------------------------------------
                if (this.modulo === 'booking') {
                    url = '/booking/destinations/';
                }
                if (this.modulo === 'services') {
                    url = '/registration/destinations/';
                }


                // >>> Send Ajax Request ---------------------------------------
                me.$vp_m();
                axios.get(url + this.desArprtCode.i)
                    .then(function(response) {  // 'OK'
                        me.$vp_um();
                        hdrs = response.headers["air41-status"];
                        switch (hdrs) {
                            case 'OK': // 'OK'

                                me.airportsReturntoother = response.data.destinationsRS.des;
                                me.airportsReturntoother.sort((a,b) => (a.l > b.l) ? 1 : ((b.l > a.l) ? -1 : 0));
                                me.returntootherLoaded = true;
                                break;
                            default: // 'ERROR'
                                // me.$toc('I am in Header Error');
                                me.$toasted.global.sdr_app_error({
                                    message : response.headers["air41-error"]
                                });
                                break;
                        };
                    })
                    .catch(function(error) { // 'ERROR'
                        me.$vp_um();
                        me.$toasted.global.sdr_app_error({
                            message : 'Service unavailable'
                        });
                    });

            }, // eo funtion call_listAirportsReturnToOther()


            /******************************************************************* Shared: 'Booking', 'Services'
            * Call::'/booking/listflights'
            * Call::'/registration/flights'
            *
            * Desc: Getting Flights ('listflights').
            * Note: Via Endpoint '/booking' or '/registration'.
            *
            */
            call_listFlights: function(params) {

                var me = this,
                    hdrs = '',
                    options = {},
                    url = '';


                me.$toc('>>> booking/flightsearch/FlighSearchTab.vue >>> call_listFlights');
                this.onChange_FlightsSearchForm(); // reset
                options = {
                    container: 'body',
                    easing: 'linear',
                    offset: -60,
                    force: true,
                    cancelable: true,
                    onStart: function(element) {
                        // scrolling started
                    },
                    onDone: function(element) {
                        // scrolling is done
                    },
                    onCancel: function() {
                        // scrolling has been interrupted
                    },
                    x: false,
                    y: true
                };

                // >>> Decide Modulo -------------------------------------------
                if (this.modulo === 'booking') {
                    url = '/booking/listflights/';
                }
                if (this.modulo === 'services') {
                    url = '/registration/flights/';
                }

                // >>> Send Ajax Request ---------------------------------------
                me.$vp_m();
                axios.put(url, params)
                    .then(function(response) { // 'OK'
                        me.$vp_um();
                        hdrs = response.headers["air41-status"];
                        switch (hdrs) {
                            case 'OK': // 'OK'
                                me.actn_setBookingFlightSearchResults(response.data.listFlightsRS.flts);
                                me.actn_FlagSharedShowFlightSearchResults(true); // Show 'Section'



                                setTimeout(function() {
                                    me.check_NoReturnFlightsOnRoundtrip();
                                    me.$scrollTo('#contentElement', 200, options);
                                }, 300);
                                break;
                            default: // 'ERROR'
                                me.$toasted.global.sdr_app_error({
                                    message : response.headers["air41-error"]
                                });
                                break;
                        };
                    })
                    .catch(function(error) { // 'ERROR'
                        me.$vp_um();
                        me.$toasted.global.sdr_app_error({
                            message : 'Service unavailable'
                        });
                    });

            }, // eo funtion call_listFlights()




            /******************************************************************* 'Listeners'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onChange_Radio_checkIfSomethingAlreadyChosen()
            *
            * Desc:
            * Note:
            *
            */
            onChange_Radio_checkIfSomethingAlreadyChosen: function() {

                var me = this;


                me.$toc('>>> shared/flightsearch/FlighSearchTab.vue >>> onChange_Radio_checkIfSomethingAlreadyChosen');
                if (this.returntoother === true && this.destinationsLoaded === true && this.desArprtCode !== '') {
                    this.call_listAirportsReturnToOther();
                }

                if (this.returntoother === false) {
                    this.depArprtCode_returntoother = '';    // reset everything
                    this.desArprtCode_returntoother = '';
                    this.airportsReturntoother = [];
                    this.returntootherLoaded = false;
                }

            }, // eo function onChange_Radio_checkIfSomethingAlreadyChosen()


            /*******************************************************************
            * onChange_FlightsSearchForm()
            *
            * Desc:
            * Note: Kind of Reset here.
            *
            */
            onChange_FlightsSearchForm: function() {

                var me = this;


                me.$toc('>>> shared/flightsearch/FlighSearchTab.vue >>> onChange_FlightsSearchForm');
                me.actn_setBookingFlightSearchResults({});
                me.actn_FlagSharedShowFlightSearchResults(false);   // set: 'Hide Section'
                me.actn_FlagBookingOutwardFlightSelected(false);    // set: 'No Outward selected'
                me.actn_FlagBookingReturnFlightSelected(false);     // set: 'No Return selected'
                me.actn_setBookingFlightIdSelectedOutward(null);    // set: selected flight id out -> null
                me.actn_setBookingFlightIdSelectedReturn(null);     // set: selected flight id ret -> null

                eventBus.$emit('needtorerender');

            }, // eo function onChange_FlightsSearchForm()


            /*******************************************************************
            * check_NoReturnFlightsOnRoundtrip()
            *
            * Desc: Check if Roundtrip has no Ret Flights. Show Message.
            * Note:
            *
            */
            check_NoReturnFlightsOnRoundtrip: function() {

                var me = this;


                me.$toc('>>> shared/flightsearch/FlighSearchTab.vue >>> check_NoReturnFlightsOnRoundtrip');
                if (this.getBookingUsersSearchData.rTrip === true && (this.filterOutwardOnly(this.getBookingFlightSearchResults).length === 0 || this.filterReturnOnly(this.getBookingFlightSearchResults).length === 0)) {
                    // me.$toasted.global.sdr_app_error({
                    //     message : me.noretflightonroundtrip[me.getCurrentLocale]
                    // });
                    me.$modal.show('booking-error-modal');
                }

            }, // eo function check_NoReturnFlightsOnRoundtrip()


            /*******************************************************************
            * filterOutwardOnly()
            *
            * Desc:
            *
            * @param {Object} flights (All Search Results Object)
            * @return {string}
            */
            filterOutwardOnly: function (flights) {

                let me = this;


                return flights.filter(function (flight) {
                    return flight.depArprt.i === me.getBookingDepArprtCode;
                });

            }, // eo function filterOutwardOnly()


            /*******************************************************************
            * filterReturnOnly()
            *
            * Desc:
            *
            * @param {Object} flights (All Search Results Object)
            * @return {string}
            */
            filterReturnOnly: function (flights) {

                let me = this;


                // me.$toc('>>> shared/flightsearch/FlightSearchResults.vue >>> filterReturnOnly');
                return flights.filter(function (flight) {
                    return flight.depArprt.i !== me.getBookingDepArprtCode;
                });

            }, // eo funtion filterReturnOnly()


            /*******************************************************************
            * onClick_CloseModal()
            *
            * Desc:
            * Note: Method Name is misleading. Only for reasons of equality.
            *
            */
            onClick_CloseModal: function() {

                var me = this;


                me.$modal.hide('booking-error-modal');

            }, // eo function onClick_CloseModal()

        }, // eof methods{}
        /* <<< ****************************************************************/

    };
</script>

<style>
    .search-box-wrapper.style1 .search-tab-content .title-container {
        background: #AB3B7A;
    }
    .search-box-wrapper.style1 .search-tab-content .title-container-srvcs {
        background: #4A6E89;
    }

    .checkbox.checked:before, .radio.checked:before {
        border-color: #AB3B7A;
        color: #fff;
        background: #AB3B7A;
        content: "\e8ba";
    }
    .radiosrvcs.checked:before {
        border-color: #4A6E89;
        color: #fff;
        background: #4A6E89;
        content: "\e8ba";
    }

    .icon-check-srvcs {
        position: relative;
        padding-right: 30px !important;
        padding-left: 0 !important;
        overflow: hidden;
    }
    .icon-check-srvcs:after {
        content: "";
        position: absolute;
        top: 0;
        right: 0;
        width: 30px;
        height: 100%;
        background: url(/res/images/icon/icon-check.png) no-repeat center center #4A6E89;
    }




    /* vue-select: volle Breite wie input.full-width, Schrift 14px */
    .style-chooser,
    .style-chooser-srvcs {
        width: 100%;
        max-width: 100%;
        display: block;
    }

    .style-chooser .vs__dropdown-toggle,
    .style-chooser-srvcs .vs__dropdown-toggle {
        width: 100%;
        border: none;
    }

    /* booking */
    .style-chooser .vs__search::placeholder,
    .style-chooser .vs__dropdown-toggle,
    .style-chooser .vs__dropdown-menu {
        background: #ab3b7a;
        color: #ffffff;
        font-size: 14px;
    }

    .style-chooser .vs__clear,
    .style-chooser .vs__open-indicator {
        fill: #ffffff;
    }

    .vs__dropdown-toggle, .vs--disabled .vs__open-indicator, .vs--disabled .vs__search, .vs--disabled .vs__selected {
        background-color: #ab3b7a;
    }



    .vs__selected {
        color: rgb(255, 255, 255);
        font-size: 14px;
    }
    .vs__select {
        color: rgb(255, 255, 255);
        font-size: 14px;
    }

    .style-chooser .vs__search,
    .style-chooser .vs__search:focus,
    .style-chooser-srvcs .vs__search,
    .style-chooser-srvcs .vs__search:focus {
        font-size: 14px;
        line-height: 2.7;
    }

    .style-chooser .vs__dropdown-option,
    .style-chooser-srvcs .vs__dropdown-option {
        color: rgb(255, 255, 255);
        font-size: 14px;
    }
    .vs__dropdown-option--highlight {
        background: #5897fb;
        color: #fff;
        font-size: 14px;
    }




    /* services */
    .style-chooser-srvcs .vs__search::placeholder,
    .style-chooser-srvcs .vs__dropdown-toggle,
    .style-chooser-srvcs .vs__dropdown-menu {
        background: #4a6e89;
        color: #ffffff;
        font-size: 14px;
    }

    .style-chooser-srvcs .vs__clear,
    .style-chooser-srvcs .vs__open-indicator {
        fill: #ffffff;
    }

    .style-chooser-srvcs .vs__dropdown-toggle,
    .style-chooser-srvcs .vs--disabled .vs__open-indicator,
    .style-chooser-srvcs.vs--disabled .vs__search,
    .style-chooser-srvcs .vs--disabled .vs__selected {
        background-color: #4a6e89;
    }



    /* booking && services — Pfeil im disabled-Zustand abgedunkelt, nicht ausblenden */
    .style-chooser.vs--disabled .vs__open-indicator,
    .style-chooser-srvcs.vs--disabled .vs__open-indicator {
        opacity: 0.6;
        fill: #ffffff;
    }





    /* EDGE - Input Field (Order: Booking, Services) */
    .style-chooser .vs--disabled .vs__clear,
    .style-chooser .vs--disabled .vs__dropdown-toggle,
    .style-chooser .vs--disabled .vs__open-indicator,
    .style-chooser .vs--disabled .vs__search,
    .style-chooser .vs--disabled .vs__selected {
        background-color: #ab3b7a;
        color: #fff;
    }


    .style-chooser-srvcs .vs--disabled .vs__clear,
    .style-chooser-srvcs .vs--disabled .vs__dropdown-toggle,
    .style-chooser-srvcs .vs--disabled .vs__open-indicator,
    .style-chooser-srvcs .vs--disabled .vs__search,
    .style-chooser-srvcs .vs--disabled .vs__selected {
        background-color: #4a6e89;
        color: #fff;
    }




    /* EDGE - Menue, Background (Order: Booking, Services) */
    .vs__dropdown-menu {
        background: #ab3b7a;
        color: #ffffff;
    }
    .style-chooser-srvcs .vs__dropdown-menu {
        background: #4a6e89;
        color: #ffffff;
    }

    /* EDGE - Schriftfarbe disabled (Booking, Services) */
    .style-chooser.vs--disabled .vs__search,
    .style-chooser.vs--disabled .vs__selected,
    .style-chooser-srvcs.vs--disabled .vs__search,
    .style-chooser-srvcs.vs--disabled .vs__selected {
        color: #fff;
        font-size: 14px !important;
    }

    /* Disabled: leicht ausgebleicht, aber volle Fläche in Markenfarbe */
    .style-chooser.vs--disabled .vs__dropdown-toggle,
    .style-chooser.vs--disabled .vs__search,
    .style-chooser.vs--disabled .vs__selected,
    .style-chooser-srvcs.vs--disabled .vs__dropdown-toggle,
    .style-chooser-srvcs.vs--disabled .vs__search,
    .style-chooser-srvcs.vs--disabled .vs__selected {
        opacity: 0.8;
    }






    /* >>> SearchResult iPAD -------------------------------------------------*/
    @media only screen
    and (min-device-width : 768px)
    and (max-device-width : 1024px)  {
        .search-box-wrapper.style1 .search-tab-content .search-content {
            padding: 18px 25px 25px;
            padding-top: 18px;
            padding-right: 10px;
            padding-bottom: 10px;
            padding-left: 10px;
        }
    }

</style>
